<button type="button" [disabled]="disabled || loading" [class]="'button --' + color + ' --' + type" [class.--disabled]="disabled" type="submit"
  (click)="clickEvent.emit()">
  <span *ngIf="!loading" class="button__text" [innerHTML]="text"></span>
  <i *ngIf="!loading" [class]="icon"></i>
  <i *ngIf="loading" class="fa fa-spinner fa-spin button__loading"></i>
</button>
